// Client boot. v1.0 full product (job B7B_SIM_CAREER_FULL_PRODUCT_SUCCESSOR_P2_BUILD_261015): one product UI for every role.
// The shell is a presentation hint from /api/v1/me; every read and write is still authorized by the server session.
// Earlier phase screens (client/ctv.ts, s04.ts, s05.ts, ops.ts, ip01.ts, la.ts) are no longer part of the bundle.
import { startV1 } from "./v1/app.ts";

startV1();
